import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {API_MAP} from '../../../core/helpers/api.map';
import {map} from 'rxjs';
import {LocationsService} from './locations.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const locationsResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(LocationsService)
    .get(API_MAP.locations + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
